import { type ReactNode } from "react";
import { Box, Tooltip } from "@mui/material";
import { Theme } from "@mui/material/styles";
import type { StreamStateValue } from "../types/streamState";
import { streamStatusColors } from "../theme";
export type { StreamStateValue } from "../types/streamState";

type StreamStateProps = {
  state?: StreamStateValue;
  size?: number;
  tooltip?: ReactNode;
};

const stateLabels: Record<StreamStateValue, string> = {
  connecting: "Connecting",
  online: "Online",
  offline: "Offline",
  timeout: "Timeout",
  unknown: "Unknown",
  error: "Error",
};

const stateColors: Record<StreamStateValue, (theme: Theme) => string> = {
  connecting: (theme) => theme.palette.warning.main,
  online: (theme) => streamStatusColors[theme.palette.mode].online,
  timeout: (theme) => theme.palette.warning.main,
  offline: (theme) => theme.palette.text.secondary,
  unknown: (theme) => theme.palette.background.paper,
  error: (theme) => streamStatusColors[theme.palette.mode].error,
};

const StreamState = ({ state, size = 18, tooltip }: StreamStateProps) => {
  const streamState: StreamStateValue = state ?? "unknown";
  const stateLabel = stateLabels[streamState];
  const getColor = stateColors[streamState];
  const radius = size / 2;
  const tooltipContent = tooltip ?? stateLabel;

  return (
    <Tooltip title={tooltipContent} placement="bottom">
      <Box
        component="span"
        sx={{
          display: "inline-block",
          width: size,
          height: size,
          borderRadius: `${radius}px`,
          bgcolor: (theme) => getColor(theme),
          border: (theme) => `1px solid ${streamState === "unknown" ? theme.palette.text.secondary : theme.palette.background.paper}`,
        }}
      />
    </Tooltip>
  );
};

export default StreamState;
